<template>
  <p class="paging">
    <app-content-nav-link
        navLinkClass="btn btn_back"
        :link="parentLink"
        :text="parentLinkName" />
  </p>
</template>

<script>
import { isNil } from 'ramda'
import { toPlural } from 'utils/helpers'

export default {
  name: 'app-content-top-nav',
  props: {
    mainItem: String,
    mainItemLinkName: {
      type: String
    },
    itemLinkName: {
      type: String
    }
  },
  computed: {
    parentLinkName() {
      return isNil(this.mainItem) ? this.$gettext('Seznam') : this.mainItem
    },
    parentLink() {
      return isNil(this.mainItemLinkName)
        ? { name: toPlural(this.$route.name) }
        : { name: this.mainItemLinkName }
    }
  },
  methods: {
    getItemLink(entity) {
      const name = isNil(this.itemLinkName)
        ? this.$route.name
        : this.itemLinkName

      return {
        name,
        params: {
          id: entity._id
        }
      }
    }
  }
}
</script>
